export default "__VITE_ASSET__D5ITFaT1__"